import cx from 'clsx';
import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as SelectArrow } from '@assets/svg/arrowDown.svg';

import Switch from '@components/uikit/Switch/Switch';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const SettingItem = ({ item, control }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const tooltipText = item.tooltipText;

  return (
    <div>
      <div className={style.settingBlock}>
        <span className={style.collapseTitle} onClick={() => setIsOpen(!isOpen)}>
          <SelectArrow className={cx(style.arrowIcon, { [style.arrowIconOpen]: isOpen })} /> {t(item.title)}
        </span>
        <div id={item.name}>
          <Switch name={item.name} control={control} disabled={item.disabledSwitcher} type="woHelperText" />
        </div>
        {tooltipText && <Tooltip content={t(tooltipText)} anchorSelect={`#${name}`} />}
      </div>
      {isOpen && (
        <div className={style.settingItemInfo}>
          <p className={style.settingItemInfoText}>{t(item.text)}</p>
        </div>
      )}
    </div>
  );
};

export default SettingItem;
